/**
 * Faculty Card Component
 * Displays a faculty/team member in a card format
 */

import styles from './FacultyCard.module.css';

export class FacultyCard {
  constructor({ name, title, image, bio, email }) {
    this.name = name;
    this.title = title;
    this.image = image;
    this.bio = bio;
    this.email = email;
  }

  render() {
    const card = document.createElement('article');
    card.className = styles.card;

    // Image
    const imageWrapper = document.createElement('div');
    imageWrapper.className = styles.imageWrapper;
    
    const img = document.createElement('img');
    img.src = this.image || '/placeholder-faculty.jpg';
    img.alt = `${this.name} - ${this.title}`;
    img.loading = 'lazy';
    
    imageWrapper.appendChild(img);
    card.appendChild(imageWrapper);

    // Content
    const content = document.createElement('div');
    content.className = styles.content;

    const name = document.createElement('h3');
    name.className = styles.name;
    name.textContent = this.name;
    content.appendChild(name);

    if (this.title) {
      const title = document.createElement('p');
      title.className = styles.title;
      title.textContent = this.title;
      content.appendChild(title);
    }

    if (this.bio) {
      const bio = document.createElement('p');
      bio.className = styles.bio;
      bio.textContent = this.bio;
      content.appendChild(bio);
    }

    if (this.email) {
      const emailLink = document.createElement('a');
      emailLink.href = `mailto:${this.email}`;
      emailLink.className = styles.email;
      emailLink.textContent = 'Contact';
      content.appendChild(emailLink);
    }

    card.appendChild(content);
    return card;
  }
}
